import React from 'react';

import { RADIUSVALUES } from '@components/modals/shared/constants';

const getExpandedText = ({ size, qExpansion = '0', withHighlight = false }) => {
  if (size && qExpansion) {
    const value = RADIUSVALUES[size].filter((v) => v.value === (qExpansion || '0'))?.[0]?.label || '';
    if (withHighlight) {
      return value && value !== '0m' ? <>e dintorni entro <span className="tp-w--l c-txt--f0">{value}</span></> : '';
    }
    return value && value !== '0m' ? `e dintorni entro ${value}` : '';
  }
  return '';
};

export default getExpandedText;
